import { fetchInitialState, requestLogin } from "@/components/access/ducks/Actions"
import App from "@/components/App"
import useWidth from "@/hooks/useWidth"
import { useAppDispatch, useAppSelector } from "@/store/store"
import { NavigationActions } from "./navigation/ducks/slice"

const mapStateToProps = ({ navigation, access }) => ({
  loggedIn: access.user.loggedIn,
  hasRouted: navigation.user.hasRouted,
})

const mapDispatchToProps = (dispatch) => ({
  fetchInitialState: () => dispatch(fetchInitialState()),
  setHasRouted: (hasRouted) => dispatch(NavigationActions.setHasRouted(hasRouted)),
  login: (email, password) => dispatch(requestLogin(email, password, true)),
})

const AppContainer = ({ theme }) => {
  const dispatch = useAppDispatch()

  const stateProps = useAppSelector(mapStateToProps)
  const dispatchProps = mapDispatchToProps(dispatch)

  const width = useWidth()

  return <App width={width} theme={theme} {...stateProps} {...dispatchProps} />
}

export default AppContainer
